module.exports = __webpack_public_path__ + "img/C140.ad732597.png";